import { 
  isCimentoSimulation, 
  sendSimulationTracking, 
  formatDateTime, 
  escapeHtml, 
  getConfig, 
  reportPhishingEmail, 
  convertItemIdToGraphId, 
  deleteEmailUsingCimentoAPI, 
  logToConsole 
} from '../common/common.js';
import 'office-ui-fabric-js/dist/css/fabric.components.css';
import './taskpane.css';

/* global document, Office */
Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {

    Office.context.mailbox.addHandlerAsync(
      Office.EventType.ItemChanged,
      onItemChanged,
      (asyncResult) => {
          if (asyncResult.status === Office.AsyncResultStatus.Failed) {
              reportError(asyncResult.error);
          } 
      }
    );

    document.getElementById("app-body").style.display = "flex";
    run();

  }

});

async function onItemChanged(eventArgs) {
  logToConsole("Test of Item changed event");
}

async function addProgressNotification(message) {
  logToConsole("Do nothing. See if this removes the error");
}

async function run() {

  let insertAt = document.getElementById("outlook-phishing-dialog");
  const item = Office.context.mailbox.item;
  if (item === null || item === undefined) {
    // Display Welcome dialog content (State 1: No email opened)
    displayWelcomeDialog(insertAt);
  } else {

    // Display Initial Reporting Information (State 2: Email Opened)
    displayReportDialogContent(item, insertAt);
    
  }

}

/**
 * Get welcome dialog content (State 1: No email opened)
 */
function getWelcomeDialogContent() {
  return `
    <div class="outlook-phishing-dialog-header">
      <h2 id="outlook-phishing-dialog-title" class="outlook-phishing-dialog-title">Cimento AI Phishing Report Button</h2>
    </div>
    <div class="outlook-phishing-dialog-content">
      <p class="outlook-phishing-dialog-body">Welcome to the Cimento AI Phishing Report Button! This add-on helps you report suspicious emails that may be phishing attempts.</p>
      <p class="outlook-phishing-dialog-body"><strong>To report a phishing email:</strong></p>
      <p class="outlook-phishing-dialog-body">1. Open any email message<br>2. Look for the "Report Phishing" button in the toolbar<br>3. Click the button to forward the email</p>
      <p class="outlook-phishing-dialog-body">The original email will be forwarded to your organization's security team for analysis.</p>
    </div>
    <div class="outlook-phishing-dialog-actions">
      <button class="ms-Button ms-Button--primary outlook-phishing-dialog-actionButtonPrimary" id="outlook-phishing-dialog-close">
        <span class="ms-Button-flexContainer">
          <span class="ms-Button-textContainer">
            <span class="ms-Button-label outlook-phishing-dialog-actionButtonLabel">OK</span>
          </span>
        </span>
      </button>
    </div>
  `;
}

/**
 * Get report dialog content (State 2: Email opened)
 */
function getReportDialogContent(emailDetails) {
  return `
    <div class="outlook-phishing-dialog-header">
      <h2 id="outlook-phishing-dialog-title" class="outlook-phishing-dialog-title">Report Email</h2>
    </div>
    <div class="outlook-phishing-dialog-content">
      <h3 class="outlook-phishing-dialog-section-title">Email Details</h3>
      <div class="outlook-phishing-dialog-detail">
        <div class="outlook-phishing-dialog-detail-label">Subject</div>
        <div class="outlook-phishing-dialog-detail-value">${escapeHtml(emailDetails.subject)}</div>
      </div>
      <div class="outlook-phishing-dialog-detail">
        <div class="outlook-phishing-dialog-detail-label">From</div>
        <div class="outlook-phishing-dialog-detail-value">${escapeHtml(emailDetails.sender.displayName)}</div>
      </div>
      <div class="outlook-phishing-dialog-detail">
        <div class="outlook-phishing-dialog-detail-label">Date</div>
        <div class="outlook-phishing-dialog-detail-value">${escapeHtml(formatDateTime(emailDetails.dateTimeCreated))}</div>
      </div>
      <h3 class="outlook-phishing-dialog-section-title" style="margin-top: 24px;">Security Actions</h3>
      <p class="outlook-phishing-dialog-body">If you suspect this email looks suspicious, please alert your security and compliance team for further review.</p>
    </div>
    <div class="outlook-phishing-dialog-actions">
      <button class="ms-Button outlook-phishing-dialog-actionButtonSecondary" type="button" id="outlook-phishing-dialog-cancel">
        <span class="ms-Button-flexContainer">
          <span class="ms-Button-textContainer">
            <span class="ms-Button-label outlook-phishing-dialog-actionButtonLabel">Cancel</span>
          </span>
        </span>
      </button>
      <button class="ms-Button ms-Button--primary outlook-phishing-dialog-actionButtonPrimary" type="button" id="outlook-phishing-dialog-report">
        <span class="ms-Button-flexContainer">
          <span class="ms-Button-textContainer">
            <span class="ms-Button-label outlook-phishing-dialog-actionButtonLabel">Report</span>
          </span>
        </span>
      </button>
    </div>
  `;
}

/**
 * Get loading dialog content (while fetching email details)
 */
function getLoadingDialogContent() {
  return `
    <div class="outlook-phishing-dialog-header">
      <h2 id="outlook-phishing-dialog-title" class="outlook-phishing-dialog-title">Loading...</h2>
    </div>
    <div class="outlook-phishing-dialog-content">
      <p class="outlook-phishing-dialog-body">Fetching email details...</p>
    </div>
  `;
}

/**
 * Get error dialog content
 */
function getErrorDialogContent(errorMessage) {
  return `
    <div class="outlook-phishing-dialog-header">
      <h2 id="outlook-phishing-dialog-title" class="outlook-phishing-dialog-title">Error</h2>
    </div>
    <div class="outlook-phishing-dialog-content">
      <p class="outlook-phishing-dialog-body">❌ ${escapeHtml(errorMessage)}</p>
    </div>
    <div class="outlook-phishing-dialog-actions">
      <button class="ms-Button ms-Button--primary outlook-phishing-dialog-actionButtonPrimary" id="outlook-phishing-dialog-close">
        <span class="ms-Button-flexContainer">
          <span class="ms-Button-textContainer">
            <span class="ms-Button-label outlook-phishing-dialog-actionButtonLabel">OK</span>
          </span>
        </span>
      </button>
    </div>
  `;
}

/**
 * Get processing dialog content (while refreshing inbox)
 * This is probably not relevant for Outlook implementation
 */
function getProcessingDialogContent() {
  return `
    <div class="outlook-phishing-dialog-header">
      <h2 id="outlook-phishing-dialog-title" class="outlook-phishing-dialog-title">Processing...</h2>
    </div>
    <div class="outlook-phishing-dialog-content">
      <p class="outlook-phishing-dialog-body">⏳ Refreshing inbox...</p>
      <p class="outlook-phishing-dialog-body">This will only take a moment.</p>
    </div>
  `;
}
  
/**
 * Get Cimento test dialog content (State 3: Cimento phishing simulation)
 */
function getCimentoTestDialogContent(emailDetails) {
  return `
    <div class="outlook-phishing-dialog-header">
      <h2 id="outlook-phishing-dialog-title" class="outlook-phishing-dialog-title">This was a Phishing Simulation</h2>
    </div>
    <div class="outlook-phishing-dialog-content">
      <p class="outlook-phishing-dialog-body">🎯 This was a phishing test email sent by your security team.</p>
      <p class="outlook-phishing-dialog-body"><strong>Great Job!</strong> You correctly identified this email simulation. This was a controlled Phishing Simulation conducted by your security team through Cimento AI. Thank you for following protocol and reporting suspicious content. To ensure accurate baseline metrics, please maintain confidentiality about this test.</p>
      <h3 class="outlook-phishing-dialog-section-title" style="margin-top: 24px;">Test Email Details</h3>
      <div class="outlook-phishing-dialog-detail">
        <div class="outlook-phishing-dialog-detail-label">Subject</div>
        <div class="outlook-phishing-dialog-detail-value">${escapeHtml(emailDetails.subject)}</div>
      </div>
      <div class="outlook-phishing-dialog-detail">
        <div class="outlook-phishing-dialog-detail-label">From</div>
        <div class="outlook-phishing-dialog-detail-value">${escapeHtml(emailDetails.sender.displayName)}</div>
      </div>
      <div class="outlook-phishing-dialog-detail">
        <div class="outlook-phishing-dialog-detail-label">Date</div>
        <div class="outlook-phishing-dialog-detail-value">${escapeHtml(formatDateTime(emailDetails.dateTimeCreated))}</div>
      </div>
      <p class="outlook-phishing-dialog-body" style="margin-top: 16px;">No action needed - this email was not forwarded to the security team.</p>
    </div>
    <div class="outlook-phishing-dialog-actions">
      <button class="ms-Button ms-Button--primary outlook-phishing-dialog-actionButtonPrimary" id="outlook-phishing-dialog-ok">
        <span class="ms-Button-flexContainer">
          <span class="ms-Button-textContainer">
            <span class="ms-Button-label outlook-phishing-dialog-actionButtonLabel">OK</span>
          </span>
        </span>
      </button>
    </div>
  `;
}

/**
 * Get success dialog content (State 4: Regular phishing report)
 * emailDetails is not used in this function
 * phishingInbox is the email address to which the email was forwarded
 * Current plan is to get this value from Azure using security attributes
 */
function getSuccessDialogContent(emailDetails, phishingInbox) {
  return `
    <div class="outlook-phishing-dialog-header">
      <h2 id="outlook-phishing-dialog-title" class="outlook-phishing-dialog-title">Report Submitted</h2>
    </div>
    <div class="outlook-phishing-dialog-content">
      <p class="outlook-phishing-dialog-body">✅ Email forwarded to ${escapeHtml(phishingInbox)} successfully!</p>
      <p class="outlook-phishing-dialog-body">The email has been forwarded for analysis. Thank you for helping to protect others from phishing attempts.</p>
    </div>
    <div class="outlook-phishing-dialog-actions">
      <!--<button class="outlook-phishing-dialog-button outlook-phishing-dialog-button-filled" id="outlook-phishing-dialog-ok">OK</button>-->
      <button class="ms-Button ms-Button--primary outlook-phishing-dialog-actionButtonPrimary" id="outlook-phishing-dialog-ok">
        <span class="ms-Button-flexContainer">
          <span class="ms-Button-textContainer">
            <span class="ms-Button-label outlook-phishing-dialog-actionButtonLabel">OK</span>
          </span>
        </span>
      </button>
    </div>
  `;
}

/*
Get content with error message and set button event handling
*/
function displayErrorMessage(errorMessage, insertAt) {
  insertAt.innerHTML = getErrorDialogContent(errorMessage);

  const closeBtn = document.getElementById('outlook-phishing-dialog-close');
  const newCloseBtn = closeBtn.cloneNode(true);
  closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);

  newCloseBtn.addEventListener('click', (e) => {

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    Office.context.ui.closeContainer();
    return false;
  }, true);

}

/*
Get content for welcome dialog and set button event handling
*/
function displayWelcomeDialog(insertAt) {
  insertAt.innerHTML = getWelcomeDialogContent();

  const closeBtn = document.getElementById('outlook-phishing-dialog-close');
  const newCloseBtn = closeBtn.cloneNode(true);
  closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);

  newCloseBtn.addEventListener('click', (e) => {

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    Office.context.ui.closeContainer();
    return false;
  }, true);

}

/*
Get content for report dialog and set button event handling
*/
function displayReportDialogContent(item, insertAt) {
  insertAt.innerHTML = getReportDialogContent(item);
  const cancelBtn = document.getElementById('outlook-phishing-dialog-cancel');
  const reportBtn = document.getElementById('outlook-phishing-dialog-report');

  const newCancelBtn = cancelBtn.cloneNode(true);
  cancelBtn.parentNode.replaceChild(newCancelBtn, cancelBtn);
  newCancelBtn.addEventListener('click', (e) => {

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    Office.context.ui.closeContainer();
    return false;
  }, true);

  const newReportBtn = reportBtn.cloneNode(true);
  reportBtn.parentNode.replaceChild(newReportBtn, reportBtn);

  if (reportBtn && (item.subject || item.sender.displayName || item.dateTimeCreated)) {
  
    newReportBtn.addEventListener('click', async (e) => {

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Show loading state
      newReportBtn.textContent = 'Reporting...';
      newReportBtn.disabled = true;

      try {
        
        // Get configuration
        const config = await getConfig();
        //const config = await getCustomerVariables();

        let simulation = await isCimentoSimulation();
        // isCimentoSimulation will always return false until we can receive
        // Outlook simulation emails from Cimento AI.
        // To test for a simulation set it to true and set the tracking id
        //simulation = { isSimulation: true, trackingId: "cimento_staging_56c73ffce34c45bda270e22a94ae18c9" };    
        
        logToConsole("Back from isCimentoSimulation what is flag " + simulation.isSimulation);
      
        if (simulation.isSimulation) {

          // Send tracking information
          await sendSimulationTracking(simulation.trackingId, config.apiKey);
          logToConsole("Sent simulation tracking");

          /*
          // State 3: Cimento phishing test email
          */
          
          displayCimentoTestDialogContent(item, insertAt, config.apiKey);

        } else {

          /*
          // State 4: Regular phishing report
          // Report the email via proxy API
          */
          if (config.apiKey)
          {
            try {

              const response = await reportPhishingEmail(
                item.itemId, 
                config.phishingInbox, 
                getUserEmail(), 
                config.tenantName, 
                config.apiKey);

                displaySuccessDialog(item, config.phishingInbox, insertAt, config.apiKey);
                return;

            } catch (error) {
              console.error("Error reporting email:", error);
              displayErrorMessage("Failed to report email. Please try again.", insertAt);
              return;
            }
          }
        }

      } catch (error) {

          console.error('Error reporting email:', error);

          displayErrorMessage('An error occurred. Please try again.', insertAt);
      }

    });
  }

}

/*
Get content for success dialog and set button event handling
*/
function displaySuccessDialog(item, phishingInbox, insertAt, apiKey) {
  insertAt.innerHTML = getSuccessDialogContent(item, phishingInbox);

  const convertedItemId = convertItemIdToGraphId(item.itemId);

  const closeBtn = document.getElementById('outlook-phishing-dialog-ok');
  const newCloseBtn = closeBtn.cloneNode(true);
  closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);

  newCloseBtn.addEventListener('click', async(e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    try {
      logToConsole("Before deleting email for dialog");
      await deleteEmailUsingCimentoAPI(convertedItemId, getUserEmail(), apiKey);
      logToConsole("After deleting email for dialog");

    } catch (error) {
      console.error("Error deleting email:", error);
    }
    logToConsole("About to close taskpane");
    Office.context.ui.closeContainer();

    return false;
  }, true);
}

/**
 * Get Cimento test dialog content (State 3: Cimento phishing simulation)
 * and set button event handling
 */
function displayCimentoTestDialogContent(item, insertAt, apiKey) {
  insertAt.innerHTML = getCimentoTestDialogContent(item);

  const convertedItemId = convertItemIdToGraphId(item.itemId);

  const closeBtn = document.getElementById('outlook-phishing-dialog-ok');
  const newCloseBtn = closeBtn.cloneNode(true);
  closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
  
  newCloseBtn.addEventListener('click', async(e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    try {
      logToConsole("Before deleting email for dialog");

      await deleteEmailUsingCimentoAPI(convertedItemId, getUserEmail(), apiKey);
      logToConsole("After deleting email for dialog after sending a normal phishing email");

    } catch (error) {
      console.error("Error deleting email for dialog after sending a normal phishing email: ", error);
    }

    Office.context.ui.closeContainer();
    return false;
  }, true);

}

/*
Get user email address
*/
function getUserEmail() {
  return Office.context.mailbox.userProfile.emailAddress;
}

function reportError(errorMessage) {
  console.error("Error from dialog:", errorMessage);
}